import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    default: String
  };

  static targets = ["inputs"];

  connect() {
    if (this.defaultValue) {
      this.defaultFilter = JSON.parse(this.defaultValue);
    } else {
      this.defaultFilter = "";
    }
  }

  reset() {
    this.inputsTarget.querySelectorAll("input").forEach((input) => {
      switch (input.type) {
        case "checkbox":
          input.checked =
            this.defaultFilter &&
            [].concat(this.defaultFilter).includes(input.value);

          break;

        case "text":
          input.value = this.defaultFilter || "";
          break;

        case "hidden":
          input.value = this.defaultFilter || "";
          break;

        default:
          break;
      }
    });
  }
}
